import { StringUtil } from '@nomidio/common';

export enum DomainStatus {
  Verified = 'VERIFIED',
  Deleted = 'DELETED',
  Pending = 'PENDING',
}

export function DomainStatusPresentation(status: DomainStatus): string {
  switch (status) {
    case DomainStatus.Verified:
      return 'Verified';
    case DomainStatus.Pending:
      return 'Pending';
    case DomainStatus.Deleted:
      return 'Deleted';
    default:
      console.warn(`Mapping not handled for type '${status}' falling back to value`);
      return StringUtil.toPresentationFormat(status);
  }
}
